// extracted by mini-css-extract-plugin
export var acceptButton = "_23-5";
export var fullContent = "_23-4";
export var link = "_23-6";
export var linkIcon = "_23-7";
export var sideContent = "_23-3";
export var sideImage = "_23-2";
export var sideImageWrapper = "_23-1";
export var splitLayout = "_23-0";